export default () => ({
  tooltipState: false,
  timeout: null,
  async copy(text) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error("Ошибка при копировании:", err);
    }
    if (this.timeout) {
        clearTimeout(this.timeout);
    }
    this.tooltipState = true;
    this.timeout = setTimeout(() => {
      this.tooltipState = false;
    }, 1500);
  },
});
